<template>
    <div class="ggmf-card latest-news-card">
        <div class="ggmf-card__header">
            <h4 class="ggmf-card__title">
                <i class="ri-newspaper-line"></i>
                Últimas Notícias
            </h4>
            <router-link to="/news" class="ggmf-card__link">Ver todas</router-link>
        </div>
        <div class="ggmf-card__body">
            <!-- Loading -->
            <div v-if="loading">
                <div v-for="i in 3" :key="i" class="news-item-skeleton"></div>
            </div>

            <!-- Sem notícias -->
            <div v-else-if="!news.length" class="empty-state">
                <i class="ri-newspaper-line"></i>
                <p>Nenhuma notícia publicada</p>
            </div>

            <!-- Lista -->
            <ul v-else class="news-list">
                <li v-for="item in news" :key="item.id" class="news-item">
                    <div class="news-item__cover">
                        <template v-if="item.coverImageUrl">
                            <video v-if="isVideo(item.coverImageUrl)" :src="item.coverImageUrl"
                                class="news-item__media"></video>
                            <img v-else :src="item.coverImageUrl" :alt="item.title_pt" class="news-item__media">
                        </template>
                        <div v-else class="news-item__cover-placeholder">
                            <i class="ri-image-line"></i>
                        </div>
                    </div>
                    <div class="news-item__info">
                        <h5 class="news-item__title">{{ item.title_pt }}</h5>
                        <div class="news-item__meta">
                            <span>
                                <i class="ri-calendar-line"></i>
                                {{ formatDate(item.publishDate) }}
                            </span>
                            <span v-if="item.readTime">
                                <i class="ri-time-line"></i>
                                {{ item.readTime }} min
                            </span>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LatestNews',
    props: {
        news: {
            type: Array,
            default: () => [],
        },
        loading: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        isVideo(url) {
            if (!url) return false;
            const videoExtensions = ['.mp4', '.webm', '.ogg', '.mov'];
            return videoExtensions.some(ext => url.toLowerCase().includes(ext));
        },
        formatDate(dateStr) {
            return new Date(dateStr).toLocaleDateString('pt-PT', {
                day: '2-digit', month: 'short', year: 'numeric',
            });
        },
    },
};
</script>

<style lang="scss">
.latest-news-card {
    margin-bottom: 24px;
}

.news-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

.news-item {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 12px 0;
    border-bottom: 1px solid #F3F4F6;

    &:last-child {
        border-bottom: none;
    }

    &__cover {
        width: 56px;
        height: 56px;
        border-radius: 12px;
        overflow: hidden;
        flex-shrink: 0;
        background: #F3F4F6;

        .news-item__media {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    &__cover-placeholder {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #9ca3af;
        font-size: 22px;
    }

    &__info {
        flex: 1;
        min-width: 0;
    }

    &__title {
        font-size: 13px;
        font-weight: 600;
        margin: 0 0 5px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    &__meta {
        display: flex;
        gap: 12px;
        font-size: 11px;
        color: #9ca3af;

        span {
            display: flex;
            align-items: center;
            gap: 3px;
        }
    }
}

.news-item-skeleton {
    height: 68px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e8e8e8 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 1.2s infinite;
    border-radius: 12px;
    margin-bottom: 10px;
}
</style>
